import messages from '../../../locale/messages';

// Landing contact form validation (same rules as ContactForm, without reCAPTCHA)
const validate = (values) => {
  const errors = {};

  // Name is required
  if (!values.name || values.name.trim() === '') {
    errors.name = messages.required;
  }

  // Email is required and must be valid
  if (!values.email) {
    errors.email = messages.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.email)) {
    errors.email = messages.emailInvalid;
  }

  // Phone is required
  if (!values.phoneNumber || values.phoneNumber.trim() === '') {
    errors.phoneNumber = messages.required;
  }

  // Message is required
  if (!values.contactMessage || values.contactMessage.trim() === '') {
    errors.contactMessage = messages.required;
  }

  return errors;
};

export default validate;
